import { render, staticRenderFns } from "./MasterSidebar.vue?vue&type=template&id=b98a0d62&"
import script from "./MasterSidebar.vue?vue&type=script&lang=js&"
export * from "./MasterSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports